var map = {
	"./logo-ru-dark.svg": 5563,
	"./pages/1.png": 3783,
	"./pages/2.png": 8956,
	"./pages/3.png": 1845,
	"./pages/4.png": 3898,
	"./sliders/slider-forte/1forte.png": 4648,
	"./sliders/slider-forte/2forte.png": 2549,
	"./sliders/slider-forte/3forte.png": 2254,
	"./sliders/slider-forte/4forte.png": 4907,
	"./sliders/slider-halyk/1halyk.png": 3526,
	"./sliders/slider-halyk/2halyk.png": 9507,
	"./sliders/slider-halyk/3halyk.png": 8952,
	"./sliders/slider-halyk/4halyk.png": 125,
	"./sliders/slider-home/0.jpeg": 2161,
	"./sliders/slider-home/2.jpeg": 599,
	"./sliders/slider-home/3.jpeg": 4816,
	"./sliders/slider-kaspi/1kaspi.png": 9192,
	"./sliders/slider-kaspi/2kaspi.png": 5709,
	"./sliders/slider-kaspi/3kaspi.png": 2902,
	"./sliders/slider-kaspi/4kaspi.png": 387,
	"./sliders/slider-we-work/1.png": 3452,
	"./sliders/slider-we-work/2.png": 7383,
	"./sliders/slider-we-work/3.png": 7886,
	"./sliders/slider-we-work/4.png": 6369,
	"./sliders/slider-we-work/5.png": 5240,
	"./sliders/slider-we-work/6.png": 851,
	"./sliders/slider-we-work/7.png": 5290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5048;